import type { PropsWithChildren } from 'react';
import { MantineProvider } from '@mantine/core';
import { PromotionsContextProvider } from '~/domains/promotions';

import { RootModalsContextProvider as BaseRootModalsContextProvider } from './RootModalsContext';
import RootModals from './RootModals';

function RootModalsContextProvider({ children }: PropsWithChildren) {
  return (
    <BaseRootModalsContextProvider>
      <PromotionsContextProvider>
        {children}
        <MantineProvider inherit theme={{ colorScheme: 'light', globalStyles: undefined }}>
          <RootModals />
        </MantineProvider>
      </PromotionsContextProvider>
    </BaseRootModalsContextProvider>
  );
}

export default RootModalsContextProvider;
